module.exports = __webpack_public_path__ + "f05bd98ae98bff796374b344e07a46c4.png";